import { useLocation, useRouterState } from '@tanstack/react-router';

// navigate 시에 현재 페이지가 아닌경우 false
export function useCurrentPageRoutingStatus({ currentPath }: { currentPath: string }): boolean {
  const location = useLocation();
  const { location: routerLocation } = useRouterState();
  const isRouting = location.pathname !== routerLocation.pathname;
  return location.pathname.includes(currentPath) && !isRouting;
}
